import { isZipOutOfArea } from '../../../shared/utility';

export function useFormInputValidation(props) {
    const {
        elementType,
        invalid,
        touched,
        shouldValidate,
        value,
        elementConfig,
        errorMessage,
        validMessage,
        helperText,
        required,
    } = props;

    let isWarning = false;
    let warningMessage = null;

    if (elementType === 'zipcode') {
        const hasRealValidationError = !!(invalid && touched);
        const patterns = (elementConfig && elementConfig.allowedCodes) || [];
        const zipOutOfArea = !hasRealValidationError && isZipOutOfArea(value, patterns);
        isWarning = !!(zipOutOfArea && touched);
        // Do not show helper text for out-of-area ZIPs, as the banner outside the input will handle the hint.
        warningMessage = null;
    }

    const isRequired = !!(
        required === true ||
        (shouldValidate && shouldValidate.required && shouldValidate.required.value === true) ||
        elementConfig?.required === true
    );

    const canValidate = !!(shouldValidate || elementType === 'zipcode');

    const isInvalid = canValidate && !isWarning && !!(invalid && touched);

    const isValid = canValidate && !isWarning && !isInvalid && (touched || !invalid);

    let calculatedHelperText = null;
    let helperType = 'none';

    if (isWarning) {
        calculatedHelperText = warningMessage;
        helperType = warningMessage ? 'warning' : 'none';
    } else if (isInvalid) {
        calculatedHelperText = errorMessage;
        helperType = 'error';
    } else if (isValid) {
        calculatedHelperText = validMessage;
        helperType = 'success';
    } else {
        calculatedHelperText = helperText;
        helperType = 'default';
    }

    return {
        isWarning,
        isInvalid,
        isValid,
        isRequired,
        helperText: calculatedHelperText,
        helperType,
    };
}
